module.exports = __webpack_public_path__ + "static/media/monthly_query_report_generation_sample.4b194aa9.csv";